<template>
  <div class="mobile-interview-card">
    <div class="card-header">
      <div class="time">
        面试时间：{{ row.interview_time || "待定时间" }}
      </div>
      <span :class="['status', statusMeta.cls]">
        {{ statusMeta.text }}
      </span>
    </div>

    <div class="card-body">
      <div class="row">
        <span class="label">候选人</span>
        <span class="value">
          <button type="button" class="candidateLink" @click="$emit('candidate-detail', row)">
            {{ row.candidate_name || "—" }}
          </button>
          <span v-if="row.candidate_phone" class="sub">
            {{ row.candidate_phone }}
          </span>
        </span>
      </div>
      <div class="row">
        <span class="label">职位</span>
        <span class="value">{{ row.position || "—" }}</span>
      </div>
      <div class="row">
        <span class="label">面试官</span>
        <span class="value">
          {{ (row.interviewer_info && row.interviewer_info.name) || "—" }}
          <span v-if="row.interviewer_info && row.interviewer_info.phone" class="sub">
            {{ row.interviewer_info.phone }}
          </span>
        </span>
      </div>
      <div class="row">
        <span class="label">招聘HR</span>
        <span class="value">
          {{ (row.recruiter_info && row.recruiter_info.name) || "—" }}
          <span v-if="row.recruiter_info && row.recruiter_info.phone" class="sub">
            {{ row.recruiter_info.phone }}
          </span>
        </span>
      </div>
      <div class="row">
        <span class="label">简历</span>
        <button
          type="button"
          class="linkLike"
          :class="{ 'linkLike--non-pdf': resumeLinkIsNonPdf }"
          :title="resumeText"
          @click="$emit('preview-resume', row)"
        >
          {{ resumeText }}
        </button>
      </div>
    </div>

    <div class="card-actions">
      <el-button
        v-if="canEnter"
        size="mini"
        native-type="button"
        v-has="'btn_join'"
        class="btnLink primary"
        @click="$emit('enter', row)"
      >
        进入面试
      </el-button>
      <el-button
        v-if="canAssess"
        size="mini"
        native-type="button"
        v-has="'btn_assess'"
        class="btnLink primary"
        @click="$emit('assess', row)"
      >
        面试评价
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileInterviewCard",
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statusMeta() {
      const n = Number(this.row && this.row.current_status);
      const map = {
        0: { text: "待通知", cls: "gray" },
        1: { text: "待开始", cls: "ok" },
        2: { text: "进行中", cls: "blue" },
        3: { text: "待评价", cls: "warn" },
        4: { text: "待复核", cls: "warn" },
        5: { text: "复核淘汰", cls: "bad" },
        6: { text: "复核通过", cls: "ok" },
      };
      return map[n] || { text: "未知状态", cls: "warn" };
    },
    canAssess() {
      const n = Number(this.row && this.row.current_status);
      return n === 3;
    },
    canEnter() {
      const n = Number(this.row && this.row.current_status);
      return n === 1 || n === 2;
    },
    resumeText() {
      const raw = this.row && this.row.resume;
      if (!raw) return "简历";
      if (typeof raw === "object") {
        return raw.originalFilename || raw.fileName || "简历";
      }
      try {
        const meta = JSON.parse(raw);
        return meta.originalFilename || meta.fileName || "简历";
      } catch (e) {
        return raw || "简历";
      }
    },
    resumeLinkIsNonPdf() {
      const raw = this.row && this.row.resume;
      if (!raw) return false;
      let fileName = "";
      if (typeof raw === "object") {
        fileName = raw.fileName || raw.originalFilename || "";
      } else {
        try {
          const meta = JSON.parse(raw);
          fileName = meta.fileName || meta.originalFilename || "";
        } catch (e) {
          fileName = "";
        }
      }
      if (!fileName) return false;
      const s = String(fileName).trim().toLowerCase();
      return !s.endsWith(".pdf");
    },
  },
};
</script>

<style scoped>
.mobile-interview-card {
  border-radius: 12px;
  border: 1px solid var(--line);
  background: #ffffff;
  padding: 10px 12px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 8px;
}

.time {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
}

.row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
}

.label {
  flex: 0 0 60px;
  color: var(--muted);
  font-size: 14px;
}

.value {
  color: var(--text);
  font-size: 14px;
}

.sub {
  font-size: 14px;
  color: var(--text);
}

.candidateLink {
  padding: 0;
  border: none;
  background: transparent;
  color: var(--brand);
  font-size: 14px;
  cursor: pointer;
  text-align: left;
}

.card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-end;
}

.card-actions .btnLink {
  flex: 0 0 auto;
  padding: 7px 12px;
  margin: 0;
  font-size: 12px;
}

.linkLike {
  padding: 0;
  border: none;
  background: none;
  color: var(--brand);
  font-size: 14px;
  cursor: pointer;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.linkLike.linkLike--non-pdf {
  color: var(--muted);
}

.linkLike.linkLike--non-pdf:hover {
  color: var(--text);
}
</style>

